<template>
  <div id="user-list">
    <!-- <portal-window  :modelValue="isPortalOpen">

      <Spreadsheet />

    </portal-window> -->

    <!-- hidden -->
    <div
      id="printSection"
      ref="printSection"
      hidden
    >
      <v-container>
        <v-row>
          <div
            v-for="item in allItems"
            :key="item.id"
          >
            <v-card-text
              class="pl-2"
              tile
            >
              <div>
                <vue-qrcode
                  tag="img"
                  :value="item.qrcodeString"
                  :options="{ width: 100 }"
                ></vue-qrcode>
                <br>
                <b style="padding-top:3px;font-size: 1.25rem; margin-left:15%">{{ item.lockerNo }}</b>
              </div>
            </v-card-text>
          </div>
        </v-row>
      </v-container>
    </div>

    <div
      id="singlePrintSection"
      ref="singlePrintSection"
      hidden
    >
      <v-container v-if="key">
        <v-row>
          <div>
            <v-card-text
              class="pl-2"
              tile
            >
              <div>
                <vue-qrcode
                  tag="img"
                  :value="key.qrcodeString"
                  :options="{ width: 100 }"
                ></vue-qrcode>
                <br>
                <b style="padding-top:3px;font-size: 1.25rem; margin-left:15%">{{ key.lockerNo }}</b>
              </div>
            </v-card-text>
          </div>
        </v-row>
      </v-container>
    </div>

    <v-card>
      <v-card-text>
        <CRUDTable
          ref="CRUDTable"
          :external-loading="loading"
          :remote-create-item="remoteCreateItem"
          :remote-update-item="remoteUpdateItem"
          :remote-delete-item="remoteDeleteItem"
          :remote-get-item="remoteGetItem"
          :fetch-list="fetchList"
          edit-with="1000px"
          :search-key-word="searchKeyWord"
          :form-config="formConfig"
          :input-configs="inputConfigs"
          :enable-print="true"
          :handle-print-this-center-q-r-code="handlePrint"
          @reset="handleReset"
          @openEditDialog="onEditDialog"
          @QRCodePrint="handleQRCodePrint"
          @getList="getList"
        >
          <template v-slot:custom-button="{ }">
          <!-- <v-btn
          class="mb-2 mr-2"

          color="primary"
          @click="openPortal"
        >

          ShowExcel
        </v-btn> -->
          </template>

        <!-- :createParamsCallback = "createParamsCallback" -->
        </CRUDTable>
      </v-card-text>
    </v-card>

    <v-expansion-panels
      multiple
      style="margin-top:12px"
    >
      <v-expansion-panel>
        <v-expansion-panel-header>LockSize</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <CRUDTable
                ref="CRUDTable"
                :external-loading="lockerSizeLoading"
                :remote-create-item="lockerSizeRemoteCreateItem"
                :remote-update-item="lockerSizeRemoteUpdateItem"
                :remote-delete-item="lockerSizeRemoteDeleteItem"
                :remote-get-item="lockerSizeRemoteGetItem"
                :fetch-list="lockerSizeFetchList"
                edit-with="1000px"
                :search-key-word="lockerSizeSearchKeyWord"
                :form-config="lockerSizeFormConfig"
                :input-configs="lockerSizeInputConfigs"
                @reset="handleReset"
                @openEditDialog="onEditDialog"
              >
              </CRUDTable>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>LockStatus</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <CRUDTable
                ref="CRUDTable"
                :external-loading="lockerStatusLoading"
                :remote-create-item="lockerStatusRemoteCreateItem"
                :remote-update-item="lockerStatusRemoteUpdateItem"
                :remote-delete-item="lockerStatusRemoteDeleteItem"
                :remote-get-item="lockerStatusRemoteGetItem"
                :fetch-list="lockerStatusFetchList"
                edit-with="1000px"
                :search-key-word="lockerStatusSearchKeyWord"
                :form-config="lockerStatusFormConfig"
                :input-configs="lockerStatusInputConfigs"
                @reset="handleReset"
                @openEditDialog="onEditDialog"
              >
              </CRUDTable>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import {
  mdiAccountOutline,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiExportVariant,
  mdiFileDocumentOutline,
  mdiPlus,
  mdiSquareEditOutline,
} from '@mdi/js'
// import { kArray, UnboundTypeError } from 'mirada'
import { ref } from 'vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { createItem, deleteItem, fetchList, getItem, updateItem } from '@/api/locker'
import { createItem as lockerSizeCreateItem,
  deleteItem as lockerSizeDeleteItem,
  fetchList as lockerSizeFetchList,
  getItem as lockerSizeGetItem,
  updateItem as lockerSizeUpdateItem } from '@/api/lockerSize'

import { createItem as lockerStatusCreateItem,
  deleteItem as lockerStatusDeleteItem,
  fetchList as lockerStatusFetchList,
  getItem as lockerStatusGetItem,
  updateItem as lockerStatusUpdateItem } from '@/api/lockerStatus'

import CRUDTable from '@/components/CRUD/CRUDTable'
import { useStore } from '@/store'
import { LockerQRReview } from './LockerManagement/LockerQRReview'

export default {
  name: 'Locker',
  components: {
    CRUDTable,
    LockerQRReview,
    VueQrcode,

  },
  methods: {

    ShowExcel() {
      // Get HTML to print from element
      let prtHtml = `${this.excelSection.innerHTML}`
      console.log('prtHtml', prtHtml)
      if (prtHtml.indexOf('<button type="button" class="not-print v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default secondary"><span class="v-btn__content"> Retry </span></button>') > 0) {
        console.log('has button')
        prtHtml = prtHtml.replace('<button type="button" class="not-print v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default secondary"><span class="v-btn__content"> Retry </span></button>', '')
      }
      console.log('replaced prtHtml', prtHtml)

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      // Open the print window
      const printCnt = `<!DOCTYPE html>
<html>
<head>
  ${stylesHtml}
</head>
<body>
  ${prtHtml}
</body>
</html>`

      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      console.log('printCnt', printCnt)

      // WinPrint.document.open();
      WinPrint.document.write(printCnt)

      // WinPrint.document.write(printCnt)

      setTimeout(() => {
        WinPrint.focus()
      }, 1000)
    },

    handleReset() {
      console.log('handleReset')
    },
    onEditDialog(action) {
      console.log('action', action)
    },
    handleQRCodePrint(item) {
      // console.log('handleQRCodePrint', item)
      this.key = item
      this.key.qrcodeString = this.getQrcodeString(this.key)

      setTimeout(() => {
        this.handleSinglePrint()
      }, 500)
    },
    getQrcodeString(input) {
      const obj = {
        id: input.id,
        type: 'key',
      }
      const objString = JSON.stringify(obj)
      console.log('objString', objString)

      return objString
    },

    getList(items) {
      this.allItems = items

      for (let i = 0; i < this.allItems.length; i++) {
        this.allItems[i].qrcodeString = this.getQrcodeString(this.allItems[i])
      }
    },

    onDataUrlChange(data) {
      console.log('onDataUrlChange', data)
    },
    handlePrint() {
      // Get HTML to print from element
      let prtHtml = `<section class='print-window'>${this.printSection.innerHTML}</section>`
      console.log('prtHtml', prtHtml)
      if (prtHtml.indexOf('<button type="button" class="not-print v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default secondary"><span class="v-btn__content"> Retry </span></button>') > 0) {
        console.log('has button')
        prtHtml = prtHtml.replace('<button type="button" class="not-print v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default secondary"><span class="v-btn__content"> Retry </span></button>', '')
      }
      console.log('replaced prtHtml', prtHtml)

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      // Open the print window
      const printCnt = `<!DOCTYPE html>
<html>
<head>
  ${stylesHtml}
</head>
<body>
  ${prtHtml}
</body>
</html>`

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(printCnt)
      } else {
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
        console.log('printCnt', printCnt)

        // WinPrint.document.open();
        WinPrint.document.write(printCnt)

        // WinPrint.document.write(printCnt)

        setTimeout(() => {
          WinPrint.focus()
          WinPrint.print()
          WinPrint.close()
        }, 1000)
      }

      return true
    },

    handleSinglePrint() {
      // Get HTML to print from element
      console.log('this.key', this.key)
      let prtHtml = `<section class='print-window'>${this.singlePrintSection.innerHTML}</section>`
      console.log('prtHtml', prtHtml)
      if (prtHtml.indexOf('<button type="button" class="not-print v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default secondary"><span class="v-btn__content"> Retry </span></button>') > 0) {
        console.log('has button')
        prtHtml = prtHtml.replace('<button type="button" class="not-print v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default secondary"><span class="v-btn__content"> Retry </span></button>', '')
      }
      console.log('replaced prtHtml', prtHtml)

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      // console.log('qrcodeRef', this.qrcodeRef)

      // ${prtHtml}

      // Open the print window
      const printCnt = `<!DOCTYPE html>
<html>
<head>
  ${stylesHtml}
</head>
<body>
  ${prtHtml}
</body>
</html>`

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(printCnt)
      } else {
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
        console.log('printCnt', printCnt)

        // WinPrint.document.open();
        WinPrint.document.write(printCnt)

        // WinPrint.document.write(printCnt)

        setTimeout(() => {
          WinPrint.focus()
          WinPrint.print()

          // WinPrint.close()
        }, 800)
      }

      return true
    },

    // createParamsCallback(params){

    //   params.limit = 0
    //   params.page = 0
    //   return params
    // }
  },

  setup() {
    const loading = ref(false)
    const searchKeyWord = ref('')
    const enablePrint = ref(true)
    const store = useStore()
    const key = ref(null)
    const printSection = ref(null)
    const singlePrintSection = ref(null)
    const allItems = ref(null)
    const qrcodeRef = ref(null)
    const privacyContent = ref('')
    const excelSection = ref(null)
    const isPortalOpen = ref(true)

    const openPortal = () => {
      // isPortalOpen.value = !isPortalOpen.value;

      const w = window.open('http://localhost:8080/MANAGE_lockerexcel', '', 'width=200,height=100')
      setTimeout(() => {
        w.resizeTo(screen.width, screen.height)
      }, 1000)

      // window.open('http://localhost:8080/MANAGE_lockerexcel', '_blank');
    }

    store
      .dispatch('lockerList/sizeList', { limit: 0, page: 0, searchKeyWord: '' })
      .then(result => {
        // console.log('lockerList/sizeList result', result)
      })
      .catch(err => {
        console.log('err', err)
      })

    store
      .dispatch('lockerList/statusList', { limit: 0, page: 0, searchKeyWord: '' })
      .then(result => {
        // console.log('lockerList/statusList result', result)
      })
      .catch(err => {
        console.log('err', err)
      })

    store
      .dispatch('lockerList/lockerList', { limit: 0, page: 0, searchKeyWord: '' })
      .then(result => {
        // console.log('lockerList/statusList result', result)
      })
      .catch(err => {
        console.log('err', err)
      })

    const lockerStatusLoading = ref(false)
    const lockerStatusSearchKeyWord = ref('')
    const lockerSizeLoading = ref(false)
    const lockerSizeSearchKeyWord = ref('')

    const formConfig = {
      title: 'Locker',
      searchLabel: 'Search for lockerNo or occupied user name ',
      headers: [
        { value: 'id', text: 'Id' },
        { value: 'center.description', text: 'Center' },
        { value: 'lockerNo', text: 'LockerNo' },
        { value: 'lockerStatus.description', text: 'LockerStatus' },
        { value: 'lockerSize.description', text: 'LockerSize' },
        { value: 'currentUser.fullName', text: 'CurrentUser Name' },
        { value: 'actions', text: 'Actions', sortable: false },
      ],

    }

    const lockerStatusFormConfig = {
      title: 'LockerStatus',
      headers: [
        { value: 'id', text: 'Id' },
        { value: 'description', text: 'Description' },
        { value: 'actions', text: 'Actions', sortable: false },
      ],
    }

    const lockerSizeFormConfig = {
      title: 'LockerSize',
      headers: [
        { value: 'id', text: 'Id' },

        { value: 'description', text: 'Description' },
        { value: 'volume', text: 'Volume' },
        { value: 'actions', text: 'Actions', sortable: false },
      ],
    }

    return {
      openPortal,
      icons: {
        mdiSquareEditOutline,
        mdiFileDocumentOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPlus,
        mdiExportVariant,
        mdiAccountOutline,
      },
      searchKeyWord,
      remoteCreateItem: createItem,
      remoteUpdateItem: updateItem,
      remoteDeleteItem: deleteItem,
      remoteGetItem: getItem,
      fetchList,
      enablePrint,
      key,
      printSection,
      allItems,
      qrcodeRef,
      singlePrintSection,
      excelSection,
      isPortalOpen,
      privacyContent,
      loading,
      inputConfigs: [
        {
          md: 12,
          propName: 'centerID',
          label: 'center',
          type: {
            name: 'select',
            storeName: 'lockerList',
            itemText: 'description',
          },
        },
        {
          md: 12,
          propName: 'lockerNo',
          label: 'LockerNo',

        },
        {
          md: 12,
          propName: 'lockerStatusID',
          label: 'lockerStatus',
          type: {
            name: 'select',
            storeName: 'lockerStatusList',
            itemText: 'description',
          },
        },
        {
          md: 12,
          propName: 'lockerSizeID',
          label: 'lockerSize',
          type: {
            name: 'select',
            storeName: 'lockerSizeList',
            itemText: 'description',
          },
        },
      ],
      formConfig,

      lockerSizeSearchKeyWord,
      lockerSizeRemoteCreateItem: lockerSizeCreateItem,
      lockerSizeRemoteUpdateItem: lockerSizeUpdateItem,
      lockerSizeRemoteDeleteItem: lockerSizeDeleteItem,
      lockerSizeRemoteGetItem: lockerSizeGetItem,
      lockerSizeFetchList,
      lockerSizeLoading,
      lockerSizeInputConfigs: [
        { md: 12, propName: 'description', label: 'Description' },
        { md: 12, propName: 'volume', label: 'Volume' },
      ],
      lockerSizeFormConfig,

      lockerStatusSearchKeyWord,
      lockerStatusRemoteCreateItem: lockerStatusCreateItem,
      lockerStatusRemoteUpdateItem: lockerStatusUpdateItem,
      lockerStatusRemoteDeleteItem: lockerStatusDeleteItem,
      lockerStatusRemoteGetItem: lockerStatusGetItem,
      lockerStatusFetchList,
      lockerStatusLoading,
      lockerStatusInputConfigs: [
        { md: 12, propName: 'description', label: 'Description' },
      ],
      lockerStatusFormConfig,

    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>

<style scoped>
#spreadsheet {
  width: 100%;
  height: 600px;
}
</style>
